export default __webpack_public_path__ + "static/media/Terminal.73b63ccb.png";